export enum ManageDashboardView {
  owned = 'owned',
  expirations = 'expirations',
  forSale = 'forSale',
  reserved = 'reserved',
  sales = 'sales',
  offers = 'offers'
}

export type ManageDashboardTabId = keyof typeof ManageDashboardView

export type ManageDashboardCounts = {
  [key in ManageDashboardTabId]: number
}

export type ManageDashboardQueryId =
  | Exclude<ManageDashboardTabId, 'offers'>
  | 'offersSent'
  | 'offersReceived'

export type ManageDashboardQueryParams = {
  activeWallet: string | undefined
  limit: number
  search?: string
}
